module.exports = __webpack_public_path__ + "img/psd-svgrepo-com.e63b0924.svg";